import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { PrimaryButtonMedium as Button } from '@xingternal/malt-button';

import PageviewTracker from '../../../Components/PageviewTracker/PageviewTracker';
import StretchButtonGroup from './../../../Components/StretchButtonGroup/StretchButtonGroup';
import FormMessage from './../../../Components/FormMessage/FormMessage';
import Spacer from './../../../Components/Spacer/Spacer';
import { CustomH, CustomP } from './../../../Components/CustomMalt/Typography';

import FileUploadExpirationModal from './FileUploadExpirationModal';
import FileUpload from './FileUpload';

import messages from './messages';

const FileUploadStep = ({
  errors,
  handleFileUploadChange,
  values: { fileUpload },
}) => (
  <>
    <PageviewTracker pageName={'wbm/Welcome/login/recovery/account/verify'} />

    <CustomH>
      <FormattedMessage {...messages.title} />
    </CustomH>

    <CustomP>
      <FormattedMessage {...messages.description} />
      <FileUploadExpirationModal />
    </CustomP>

    <FileUpload
      value={fileUpload}
      messages={messages}
      onChange={handleFileUploadChange}
    />

    <Spacer size={4} />

    <FormMessage error={errors.fileUpload} />

    <StretchButtonGroup>
      <Button disabled={!fileUpload || errors.fileUpload} type={'submit'}>
        <FormattedMessage {...messages.buttonContinue} />
      </Button>
    </StretchButtonGroup>
  </>
);

FileUploadStep.propTypes = {
  handleFileUploadChange: PropTypes.func.isRequired,
  values: PropTypes.shape({ fileUpload: PropTypes.any }),
  errors: PropTypes.shape({ fileUpload: PropTypes.any }),
};

export default FileUploadStep;
